import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal, SecondaryButton, PrimaryButton, Select } from '@shape-ds/components';
import './Modal.scss';

export type Props = {
  ableToOperate: boolean;
  handleChange: (value: boolean) => void;
};

const AbleToOperateModal = ({ ableToOperate, handleChange }: Props) => {
  const { t } = useTranslation();
  const [selectValue, setSelectValue] = useState<boolean>(ableToOperate);
  const { closeModal } = useModal();

  const outOfServiceOptions = [
    { label: t('case:ableToOperate.options.yes'), value: 'true' },
    { label: t('case:ableToOperate.options.no'), value: 'false' },
  ];

  return (
    <div className="case-able-to-operate-modal" data-testid="case-able-to-operate-modal">
      <div className="case-able-to-operate-modal-title">{t('case:ableToOperate.modal.title')}</div>
      <Select
        label={t('case:ableToOperate.modal.label')}
        data={outOfServiceOptions}
        onChange={(event) => {
          setSelectValue(event.target.value as boolean);
        }}
        value={`${selectValue}`}
      />
      <span>{t('case:ableToOperate.modal.description')}</span>

      <div className="case-able-to-operate-modal-buttons">
        <SecondaryButton
          onClick={() => {
            closeModal();
          }}
        >
          {t('case:ableToOperate.modal.cancel')}
        </SecondaryButton>
        <PrimaryButton
          onClick={() => {
            handleChange(selectValue);
            closeModal();
          }}
        >
          {t('glossary:action_buttons.save')}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default AbleToOperateModal;
